import { Card, CardContent, FormControl, Grid } from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import CustomCardSubHeading from 'components/CustomCardHeading/CustomCardSubHeading.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import NumberInput from 'components/Wrappers/materialUIWrappers/components/NumberInput';
import { percentage } from 'helpers/ValidationHelpers';
import React from 'react';
import { Field } from 'redux-form';
import { addMonths } from 'date-fns';
import CustomChipLeft from "components/CustomChip/CustomChipLeft.jsx";
import CustomChipLeftReversed from '../../../../components/CustomChip/CustomChipLeftReversed';
import { dateValid, isEmptyOrSpaces } from 'helpers/ValidationHelpers';
import { IconButton } from '@material-ui/core';


const required = value => (value ? undefined : 'Required');

const dates = () => {
	let options = [];
	const today = new Date();
	for (var i = 0; i < 2; i++) {
		const monthX = addMonths(today, i + 2);
		var month = monthX.getMonth();
		if (month < 1)
			month = 12;

		if (month < 10) {
			var item = '01/0' + month + '/' + today.getFullYear();
			if (item.includes("/00/"))
				item.replace("/00/", "/12/")
			options.push(item);
		}

		else {
			var item = '01/' + month + '/' + today.getFullYear()
			if (item.includes("/00/"))
				item.replace("/00/", "/12/")
			options.push(item);
		}



	}

	return options;
};

const makeOptions = values => {
	const options = [{ value: 'validationError', displayValue: 'Please select' }];
	for (let value of values) {
		if (typeof value === 'object') {
			options.push(value);
		} else {
			options.push(value);
		}
	}

	return options;
};

const CustomField = props => (
	<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props}
			/>
		</FormControl>
	</GridItem>
);

const CustomFieldFullWidth = props => (
	<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

props => 0;



class QuoteDetailsPage extends React.Component {
	componentDidMount() {
		this.props.scrollMeBar();
	};

	render() {
		var dependentsAdult = [];
		var dependentsChild = [];
		var dMAmount = [];
		var dMAmountMain = [];

		for (var k = 0; k < this.props.medicalAmount; k++) {
			//alert(this.props.dependentMedicalAmount[i])
			if (1 == 0) //This is removed for now. To render it again, remove this if statement.
				dMAmountMain[k] =
					(
						<Grid container>
							<GridItem xs={12} sm={12} md={4} style={{ marginBottom: '25px' }}>
								<CustomFieldFullWidth
									name={'previousMedicalName' + k}
									component={FormDropdown}
									checkValidation={this.props.checkValidation}
									label={'Previous medical aid name'}
									isrequired={true}
									//validate={[required]}
									options={[
										{ value: 'English', displayValue: 'English' },
										{ value: 'Afrikaans', displayValue: 'Afrikaans' }
									]}
								/>
							</GridItem>
							<GridItem xs={12} sm={12} md={4} style={{ marginBottom: '25px' }}>
								<CustomFieldFullWidth
									label='Start Date'
									name={'pMedicalStart' + k}
									component={FormInput}
									placeholder={'DD/MM/YYYY'}
									validate={[dateValid]}

								/>
							</GridItem>
							<GridItem xs={12} sm={12} md={4} style={{ marginBottom: '25px' }}>
								<CustomFieldFullWidth
									label='End Date'
									name={'pMedicalEnd' + k}
									component={FormInput}
									placeholder={'DD/MM/YYYY'}
									validate={[dateValid]}

								/>
							</GridItem>
						</Grid>
					)
		}

		for (var i = 0; i < this.props.dependentsAdult.length; i++) {
			var z = this.props.dependentsAdult[i].id;
			var AmountMedical = [];
			for (var k = 0; k < this.props.dependentsAdult[i].prevMeds.length; k++) {
				//alert(this.props.dependentMedicalAmount[i])
				if (1 == 0) //This is removed for now. To render it again, remove this if statement.
					AmountMedical.push(
						(
							<Grid container>
								<GridItem xs={12} sm={12} md={4} style={{ marginBottom: '25px' }}>
									<CustomFieldFullWidth
										name={'previousMedicalName' + z}
										component={FormDropdown}
										checkValidation={this.props.checkValidation}
										label={'Previous medical aid name'}
										isrequired={true}
										//validate={[required]}
										options={[
											{ value: 'English', displayValue: 'English' },
											{ value: 'Afrikaans', displayValue: 'Afrikaans' }
										]}
									/>
								</GridItem>
								<GridItem xs={12} sm={12} md={4} style={{ marginBottom: '25px' }}>
									<CustomFieldFullWidth
										label='Start Date'
										name={'pMedicalStart' + z + ":" + k}
										component={FormInput}
										placeholder={'DD/MM/YYYY'}
										validate={[dateValid]}

									/>
								</GridItem>
								<GridItem xs={12} sm={12} md={4} style={{ marginBottom: '25px' }}>
									<CustomFieldFullWidth
										label='End Date'
										name={'pMedicalEnd' + z + ":" + k}
										component={FormInput}
										placeholder={'DD/MM/YYYY'}
										validate={[dateValid]}

									/>
								</GridItem>
							</Grid>
						))
			}


			dMAmount[i] = AmountMedical
			console.log(this.props.dependentsAdult.length)
			console.log(this.props.dependentsAdult[i].prevMeds.length)
			console.log(AmountMedical)
			console.log(dMAmount[i])

			dependentsAdult[i] =
				(

					<Grid container>

						<CustomChipLeftReversed
							text=""
							name={'adultDepRemove' + z}
							icon="remove"
							clicked={e => this.props.handleRemoveDependentAdult(e)}
							style={{ margin: "0px 0px 0px 0px" }}


						/>

						<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
							<CustomCardSubHeading
								subheading={"Adult Member" + (i + 1) + ":"}
							/>



							<CustomFieldFullWidth
								label='Date of birth'
								name={'adultDepDateOfBirth' + i}
								component={FormInput}
								placeholder={'DD/MM/YYYY'}
								validate={[dateValid]}
								onChange={e => this.props.changeDependentDob(e)}

							/>
						</GridItem>

						{
							
							 
							new Date().getFullYear() - new Date(this.props.dependentsAdult[i].dob.split("/")[1] + "/" + this.props.dependentsAdult[i].dob.split("/")[0] + "/" + this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear() > 34 &&
							new Date().getFullYear() - new Date(this.props.dependentsAdult[i].dob.split("/")[1] + "/" + this.props.dependentsAdult[i].dob.split("/")[0] + "/" + this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear() < 150 &&

							<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
								<CustomFieldFullWidth
									name={'yearsWithoutM' + i}
									component={FormInput}
									checkValidation={this.props.checkValidation}
									label={'Years covered by medical aid'}
									isrequired={true}
									onChange={e => this.props.changeDependentWithoutMed(e)}
								//validate={[required]}
								/>
							</GridItem>
						}

						{
							new Date().getFullYear() - new Date(this.props.dependentsAdult[i].dob.split("/")[1] + "/" + this.props.dependentsAdult[i].dob.split("/")[0] + "/" + this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear() > 34 &&
							new Date().getFullYear() - new Date(this.props.dependentsAdult[i].dob.split("/")[1] + "/" + this.props.dependentsAdult[i].dob.split("/")[0] + "/" + this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear() < 150 &&


							<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
								<CustomFieldFullWidth
									name={'previousMedicalAmount' + z}
									component={FormDropdown}
									checkValidation={this.props.checkValidation}
									label={'How many previous medical aids'}
									isrequired={true}
									//validate={[required]}
									onChange={e => this.props.handleMedicalAmountChangeD(e)}
									options={makeOptions([
										{ value: " ", displayValue: 'Please select' },
										{ value: z + ':1', displayValue: '1' },
										{ value: z + ':2', displayValue: '2' },
										{ value: z + ':3', displayValue: '3' },
										{ value: z + ':4', displayValue: '4' },
										{ value: z + ':5', displayValue: '5' },
										{ value: z + ':6', displayValue: '6' },
										{ value: z + ':7', displayValue: '7' },
										{ value: z + ':8', displayValue: '8' },
										{ value: z + ':9', displayValue: '9' },
										{ value: z + ':10', displayValue: '10' }
									])}
								/>

								{dMAmount[i]}
							</GridItem>
						}


					</Grid>


				);
		}

		for (var i = 0; i < this.props.dependentsChild.length; i++) {
			var z = this.props.dependentsChild[i].id;
			dependentsChild[i] =
				(
					<div key={i}>
						<GridItem xs={12} sm={12} md={3} style={{ marginBottom: '25px' }}>
							<CustomChipLeftReversed
								text=""
								name={'childDepRemove' + z}
								icon="remove"
								clicked={e => this.props.handleRemoveDependentChild(e)}
								style={{ margin: "0px 0px 0px 0px" }}


							/></GridItem>
						<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
							<CustomCardSubHeading
								subheading={"Child Member" + (i + 1) + ":"}
							/>

							<CustomFieldFullWidth
								label='Date of birth'
								name={'childDepDateOfBirth' + z}
								component={FormInput}
								placeholder={'DD/MM/YYYY'}
								validate={[dateValid]}
								value={this.props.dependentsChild[i]}
								onChange={e => this.props.changechildDob(e, i, e.target.value)}

							/>
						</GridItem>
					</div>

				);
		}


		return (
			<div className="contentWithStepper">
				<Card>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="General Quote Details"
						/>
						<Grid container>
							<CustomFieldFullWidth
								name={'description'}
								component={FormInput}
								checkValidation={this.props.checkValidation}
								label={'Quote Description *'}
								isrequired={true}
								validate={[required]}
							/>

							<CustomField
								name={'language'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Language *'}
								isrequired={true}
								validate={[required]}
								options={[

									{ value: 'English', displayValue: 'English' },
									{ value: 'Afrikaans', displayValue: 'Afrikaans' }
								]}
							/>

							<CustomField
								name={'startDate'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Start Date *'}
								isrequired={true}
								validate={[required]}
								onChange={e => this.props.changeStartDate(e)}
								options={makeOptions(dates())}
							/>

							<CustomField
								name={'student'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Is the main member a student?'}
								isrequired={true}
								validate={[required]}
								options={makeOptions([

									{ value: 'Y', displayValue: 'Yes' },
									{ value: 'N', displayValue: 'No' }
								])}
							/>

							<CustomField
								name={'hSaver'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Would you like to add extra savings?'}
								isrequired={true}
								onChange={e => this.props.changeHSaverOption(e)}
								validate={[required]}
								options={makeOptions([

									{ value: "1", displayValue: 'Yes' },
									{ value: "0", displayValue: 'No' }
								])}
							/>


						</Grid>
						<CardContent>
							<Grid container>


								{
									this.props.clientAge > 34 &&
									<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
										<CustomCardSubHeading
											subheading="Main Member:"
										/>
									</GridItem>
								}

								{
									this.props.clientAge > 34 &&

									<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
										<CustomFieldFullWidth
											name={'yearsWithoutM'}
											component={FormInput}
											checkValidation={this.props.checkValidation}
											label={'Years covered by medical aid'}
											isrequired={true}
											onChange={e => this.props.changeWithoutMed(e)}

											validate={[required]}
										/>
									</GridItem>
								}

								{
									this.props.clientAge > 34 &&

									<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>


										<CustomFieldFullWidth
											name={'previousMedicalAmount'}
											component={FormDropdown}
											checkValidation={this.props.checkValidation}
											label={'How many previous medical aids'}
											isrequired={true}
											//validate={[required]}
											onChange={e => this.props.handleMedicalAmountChange(0, e)}
											options={makeOptions([

												{ value: '1', displayValue: '1' },
												{ value: '2', displayValue: '2' },
												{ value: '3', displayValue: '3' },
												{ value: '4', displayValue: '4' },
												{ value: '5', displayValue: '5' },
												{ value: '6', displayValue: '6' },
												{ value: '7', displayValue: '7' },
												{ value: '8', displayValue: '8' },
												{ value: '9', displayValue: '9' },
												{ value: '10', displayValue: '10' }
											])}
										/>
									</GridItem>
								}




								{dMAmountMain}


								<Grid container>
									<GridItem xs={12} sm={12} md={2} style={{ marginBottom: '25px' }}>
										<CustomChipLeft
											text="Add Adult dependant"
											icon="add"
											clicked={e => this.props.handleAddDependentAdult(e)}


										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={10} style={{ marginBottom: '25px' }}></GridItem>
									<GridItem xs={12} sm={12} md={2} style={{ marginBottom: '25px' }}>

										<CustomChipLeft
											text="Add Child dependant"
											icon="add"
											clicked={e => this.props.handleAddDependentChild(e)}

										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={10} style={{ marginBottom: '25px' }}></GridItem>
								</Grid>

								{dependentsAdult}



								{dependentsChild}

							</Grid>
						</CardContent>
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default QuoteDetailsPage;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/QuoteDetails.jsx